import React from 'react';
import styled from 'styled-components';
import { FlexContainer } from '../../styled/layout.styled';
import Card from './Card';
import coinWalletIcon from './assets/Coin-Wallet.png';
import shieldIcon from './assets/Shield.png';
import messageIcon from './assets/Message.png';

const StyledFlexContainer = styled(FlexContainer)`
  display: none;

  @media only screen and (max-width: 568px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 80px;
  }
`;

const MOBILE_LIST = [
  {
    id: 0,
    image: coinWalletIcon,
    title: 'Instant Payouts',
    description: 'Zero Fees',
    alt: 'coin wallet',
  },
  {
    id: 1,
    image: shieldIcon,
    title: '100% Fairness',
    description: 'In-house Games',
    alt: 'shield',
  },
  {
    id: 2,
    image: messageIcon,
    title: '1:1 Customer',
    description: 'Service Available',
    alt: 'message',
  },
];

const LoginMobileList = () => (
  <StyledFlexContainer>
    {MOBILE_LIST.map(({
      id, image, title, description, alt,
    }) => (
      <Card key={id} image={image} title={title} description={description} alt={alt} />
    ))}
  </StyledFlexContainer>
);

export default LoginMobileList;
